import React from 'react';
import Modal from '.';
import Icon from '../Icon';
import MatchHistory from '../MatchHistory';

export default function ModalMatchHistory(props) {
  const { isOpen, toggle, exchangeOrderMatch, t } = props;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <div className='km__p--order-history-title'>
        Eşleşme Detayları
        <div>
          <Icon name='x' size='16' onClick={toggle} />
        </div>
      </div>
      <MatchHistory exchangeOrderMatch={exchangeOrderMatch} t={t} />
    </Modal>
  );
}
